import { z } from 'zod';

const ProductConfiguration = {
    ACCESS: 'access',
    OMNI: 'omni',
    DEALER: 'dealer',
};
const productConfigurationValues = [
    ProductConfiguration.ACCESS,
    ProductConfiguration.OMNI,
    ProductConfiguration.DEALER,
];
const productConfigurationSchema = z.enum(productConfigurationValues);

export { ProductConfiguration, productConfigurationSchema, productConfigurationValues };
//# sourceMappingURL=ProductConfigurationOptions.js.map
